import { ApiState, Action } from '../../../../../types';
import { serviceReducer, callService } from '../../../../../shared/hooks/serviceReducer';
import { FlowCommentList, FlowCommentsFilter } from '../../../../../services/types/Flow';

export type FlowCommentsAction =
  | Action<FlowCommentList, FlowCommentsFilter>
  | { type: 'QUERY'; value: string | null }
  | { type: 'PAGE'; value: number };

const reducer = (
  state: ApiState<FlowCommentList, FlowCommentsFilter>,
  action: FlowCommentsAction
): ApiState<FlowCommentList, FlowCommentsFilter> => {
  switch (action.type) {
    case 'QUERY': {
      return callService(state, { queryType: action.value });
    }
    case 'PAGE':
      return callService(state, { pageNumber: action.value });
    default:
      return serviceReducer(state, action);
  }
};

export default reducer;
